// src/components/NotFound/index.js
import React, {Component} from 'react'

import './style.css'

export default class NotFound extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

  render() {
    const {...props} = this.props
    return (
      <div {...props}>
        <h1>
          404 <small>Not Found :(</small>
        </h1>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/NotFound/index.js
 **/